import React from 'react';
import YantramanavBlack from './yantramanav.black.ttf';
import YantramanavBold from './yantramanav.bold.ttf';
import YantramanavLight from './yantramanav.light.ttf';
import YantramanavMedium from './yantramanav.medium.ttf';
import YantramanavRegular from './yantramanav.regular.ttf';
import YantramanavThin from './yantramanav.thin.ttf';
import LilitaOne from './lilitaone.regular.ttf';

const YantramanavFontFaces = () => (
  <style
    dangerouslySetInnerHTML={{
      __html: `
    @font-face {
      font-family: 'ChallYantramanav';
      src: url(${YantramanavBlack}) format('truetype');
      font-weight: 900;
      font-style: normal;
    }

    @font-face {
      font-family: 'ChallYantramanav';
      src: url(${YantramanavBold}) format('truetype');
      font-weight: 800;
      font-style: normal;
    }

    @font-face {
      font-family: 'ChallYantramanav';
      src: url(${YantramanavMedium}) format('truetype');
      font-weight: bold;
      font-style: normal;
    }

    @font-face {
      font-family: 'ChallYantramanav';
      src: url(${YantramanavRegular}) format('truetype');
      font-weight: 400;
      font-style: normal;
    }

    @font-face {
      font-family: 'ChallYantramanav';
      src: url(${YantramanavLight}) format('truetype');
      font-weight: 300;
      font-style: normal;
    }

    @font-face {
      font-family: 'ChallYantramanav';
      src: url(${YantramanavThin}) format('truetype');
      font-weight: 200;
      font-style: normal;
    }

    @font-face {
      font-family: 'ChallLilitaOne';
      src: url(${LilitaOne}) format('truetype');
    }
  `
    }}
  />
);

export default YantramanavFontFaces;
